import api from "./api";

const StockReturnReportService = {

    getReport: async (params) => {

        const response =
            await api.get(
                "/stockReturnReport/getReport",
                {
                    params: {
                        companyId: params.companyId || undefined,
                        employeeId: params.employeeId || undefined,
                        roleId: params.roleId || undefined,
                        projectCategoryId: params.projectCategoryId || undefined,
                        projectId: params.projectId || undefined,
                        storeId: params.storeId || undefined,
                        locationId: params.locationId || undefined,
                        status: params.status || undefined,
                        startDate: params.startDate || undefined,
                        endDate: params.endDate || undefined,
                        page: params.page || 1,
                        limit: params.limit || 10
                    }
                }
            );

        return response.data;
    }
};

export default StockReturnReportService;